import { useChatContext } from '../../contexts/AppDataContext';
import '../../Styles/Auth/404.css';
import '../../Styles/AuthForms.css';
import { Header } from '../Header/Header';

export const ChatNotFound = () => {
  const { isSpaceChat } = useChatContext();
  const message = "This chat doesn't exist.";

  if (isSpaceChat) {
    return null;
  }

  return (
    <>
      <Header />
      <div className="not-found-page">
        <div className="not-found-content">
          <p className="not-found-message">{message}</p>
        </div>
      </div>
    </>
  );
};
